import { BoxCutDefault } from '../../../components/boxCut'

export class _BoxCutCustom extends BoxCutDefault {
  protected initPC(): this {
    super.initPC()
    this['--box-cut-border-radius'] = '0.22rem'
    return this
  }
  protected initH5(): this {
    super.initH5()
    this['--box-cut-border-radius'] = '0.26rem'
    return this
  }
}
